module.exports = __webpack_public_path__ + "img/d6.042b9230.svg";